import React, { useState } from 'react'
import { FiDownload } from 'react-icons/fi'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material'

const CampaignManagementPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState([
    {
      campaignId: 'CMP-001',
      name: 'Referral Free Month',
      type: 'Subscription Waiver',
      condition: 'Refer >= 5 Patients',
      reward: 'Waive 1 Month Subscription',
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      status: 'Active',
    },
    {
      campaignId: 'CMP-002',
      name: 'Referral Commission Discount',
      type: 'Commission Reduction',
      condition: 'Refer >= 10 Patients',
      reward: 'Reduce Commission by 0.5%',
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      status: 'Active',
    },
    {
      campaignId: 'CMP-003',
      name: 'New Signup Promo',
      type: 'Period-based Promotion',
      condition: 'Signup Between Jan 1 - Mar 31',
      reward: 'Free 2 Months + 2% Off Commission',
      startDate: '2024-01-01',
      endDate: '2024-03-31',
      status: 'Upcoming',
    },
  ])

  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  // 🔹 Dialog State
  const [openDialog, setOpenDialog] = useState(false)
  const [newCampaign, setNewCampaign] = useState({
    name: '',
    campaignType: '',
    condition: '',
    rewardType: '',
    rewardValue: '',
    startDate: '',
    endDate: '',
  })

  const handleDialogOpen = () => setOpenDialog(true)
  const handleDialogClose = () => setOpenDialog(false)

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setNewCampaign({ ...newCampaign, [e.target.name]: e.target.value })
  }

  const handleAddCampaign = () => {
    // Construct the campaign type based on campaign type and reward type
    const campaignTypeDisplay = `${newCampaign.campaignType} -> ${newCampaign.rewardType}`

    // Construct the reward based on reward type and value
    const rewardDisplay =
      newCampaign.rewardType === 'Subscription Waiver'
        ? `Waive ${newCampaign.rewardValue}`
        : newCampaign.rewardType === 'Commission Discount'
          ? `Reduce Commission by ${newCampaign.rewardValue}`
          : `${newCampaign.rewardValue}`

    setCampaigns([
      ...campaigns,
      {
        campaignId: `CMP-${campaigns.length + 1}`,
        name: newCampaign.name,
        type: campaignTypeDisplay,
        condition: newCampaign.condition,
        reward: rewardDisplay,
        startDate: newCampaign.startDate,
        endDate: newCampaign.endDate,
        status: 'Active',
      },
    ])
    setNewCampaign({
      name: '',
      campaignType: '',
      condition: '',
      rewardType: '',
      rewardValue: '',
      startDate: '',
      endDate: '',
    })
    handleDialogClose()
  }

  // 🔹 Filter campaigns
  const filteredCampaigns = campaigns.filter(c => {
    const searchMatch =
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.campaignId.toLowerCase().includes(search.toLowerCase())
    const statusMatch = statusFilter ? c.status === statusFilter : true
    const startDateMatch = startDate ? c.startDate >= startDate : true
    const endDateMatch = endDate ? c.endDate <= endDate : true
    return searchMatch && statusMatch && startDateMatch && endDateMatch
  })

  const totalCampaigns = filteredCampaigns.length
  const activeCampaigns = filteredCampaigns.filter(
    c => c.status === 'Active'
  ).length
  const inactiveCampaigns = filteredCampaigns.filter(
    c => c.status === 'Inactive'
  ).length

  return (
    <div className="p-6 mx-auto max-w-7xl">
      <div className="flex flex-col items-start justify-between gap-4 mb-2 sm:flex-row sm:items-center">
        <h1 className="text-2xl font-semibold text-[#026730]">Campaigns</h1>

        <div className="flex gap-2 ml-auto">
          {/* <button
            className="flex items-center h-12 gap-2 px-4 py-2 text-gray-700 transition-colors border border-gray-300 rounded-lg hover:bg-gray-50"
            onClick={handleDialogOpen}
          >
            Add Campaign
          </button> */}

          <button className="flex items-center h-12 gap-2 px-4 py-2 text-gray-700 transition-colors border border-gray-300 rounded-lg hover:bg-gray-50">
            <FiDownload className="w-4 h-4" />
            Export CSV
          </button>
        </div>
      </div>

      {/* Search + Filters */}
      {/* <div className="flex flex-wrap gap-4 mb-6">
        <input
          type="text"
          placeholder="Campaign Name"
          className="flex-1 min-w-[180px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select
          className="flex-1 min-w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
        >
          <option value="">Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
        <input
          type="date"
          className="flex-1 min-w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
        />
        <input
          type="date"
          className="flex-1 min-w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
        />
      </div> */}
      <div className="flex flex-wrap justify-end gap-4 mb-6">
        <input
          type="text"
          placeholder="Campaign Name"
          className="h-12 px-4 border border-gray-300 rounded-lg w-60 focus:ring-2 focus:ring-green-500 focus:outline-none"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <select
          className="h-12 px-2 border border-gray-300 rounded-lg w-60 focus:ring-2 focus:ring-green-500 focus:outline-none"
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
        >
          <option value="">Status</option>
          <option value="Active">Active</option>
          <option value="Upcoming">Upcoming</option>
          <option value="Inactive">Inactive</option>
        </select>
        <input
          type="date"
          className="flex-1 min-w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
        />
        <input
          type="date"
          className="flex-1 min-w-[150px] h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
        />

        <Button variant="contained" color="primary" onClick={handleDialogOpen}>
          + Add Campaign
        </Button>
      </div>

      {/* Cards */}
      {/* <div className="grid grid-cols-1 gap-6 mb-6 sm:grid-cols-3">
        <div className="flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow h-35">
          <h2 className="text-xl font-bold text-gray-900">{totalCampaigns}</h2>
          <p className="text-sm text-gray-500">Total Campaigns</p>
        </div>
        <div className="flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow">
          <h2 className="text-xl font-bold text-green-600">
            {activeCampaigns}
          </h2>
          <p className="text-sm text-gray-500">Active</p>
        </div>
        <div className="flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow">
          <h2 className="text-xl font-bold text-red-600">
            {inactiveCampaigns}
          </h2>
          <p className="text-sm text-gray-500">Inactive</p>
        </div>
      </div> */}
      <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-3">
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow h-35">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">3</h2>
            <p className="text-sm text-gray-500">Total Campaign</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-green-600 bg-green-100 rounded-full">
            👥
          </div>
        </div>
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">1</h2>
            <p className="text-sm text-gray-500">Active Campaign</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-blue-600 bg-blue-100 rounded-full">
            ✅
          </div>
        </div>
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">1</h2>
            <p className="text-sm text-gray-500">Inactive Camapign</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-red-600 bg-red-100 rounded-full">
            ❌
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-gray-600 uppercase">
                <th className="px-6 py-3 font-medium">Campaign Name</th>
                <th className="px-6 py-3 font-medium">Type</th>
                <th className="px-6 py-3 font-medium">Condition</th>
                <th className="px-6 py-3 font-medium">Reward</th>
                <th className="px-6 py-3 font-medium">Start Date</th>
                <th className="px-6 py-3 font-medium">End Date</th>
                <th className="px-6 py-3 font-medium">Status</th>
                <th className="px-6 py-3 font-medium">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredCampaigns.length > 0 ? (
                filteredCampaigns.map(c => (
                  <tr key={c.campaignId} className="hover:bg-gray-50">
                    <td className="px-6 py-4">{c.name}</td>
                    <td className="px-6 py-4">{c.type}</td>
                    <td className="px-6 py-4">{c.condition}</td>
                    <td className="px-6 py-4">{c.reward}</td>
                    <td className="px-6 py-4">
                      {new Date(c.startDate).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4">
                      {new Date(c.endDate).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium border ${
                          c.status === 'Active'
                            ? 'border-green-500 text-green-600 bg-green-50'
                            : c.status === 'Upcoming'
                              ? 'border-blue-500 text-blue-600 bg-blue-50'
                              : 'border-red-500 text-red-600 bg-red-50'
                        }`}
                      >
                        {c.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button className="p-2 text-gray-600 rounded hover:text-red-600 hover:bg-red-50">
                        {c.status === 'Active' ? (
                          <ToggleOnIcon style={{ color: 'green' }} />
                        ) : (
                          <ToggleOffIcon style={{ color: 'red' }} />
                        )}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    No campaigns found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Campaign Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Add New Campaign</DialogTitle>
        <DialogContent className="flex flex-col gap-4">
          <TextField
            label="Campaign Name"
            name="name"
            value={newCampaign.name}
            onChange={handleInputChange}
            fullWidth
            placeholder="e.g., Referral Free Month"
          />

          {/* Campaign Type Dropdown */}
          <FormControl fullWidth>
            <InputLabel>Campaign Type</InputLabel>
            <Select
              name="campaignType"
              value={newCampaign.campaignType}
              onChange={e =>
                setNewCampaign({ ...newCampaign, campaignType: e.target.value })
              }
              label="Campaign Type"
            >
              <MenuItem value="Referral">Referral</MenuItem>
              <MenuItem value="Promotion">Promotion</MenuItem>
              <MenuItem value="Custom">Custom</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Condition"
            name="condition"
            value={newCampaign.condition}
            onChange={handleInputChange}
            fullWidth
            placeholder="e.g., Refer >= 5 Patients"
          />

          {/* Reward Type Dropdown */}
          <FormControl fullWidth>
            <InputLabel>Reward Type</InputLabel>
            <Select
              name="rewardType"
              value={newCampaign.rewardType}
              onChange={e =>
                setNewCampaign({ ...newCampaign, rewardType: e.target.value })
              }
              label="Reward Type"
            >
              <MenuItem value="Subscription Waiver">
                Subscription Waiver
              </MenuItem>
              <MenuItem value="Commission Discount">
                Commission Discount
              </MenuItem>
              <MenuItem value="Mixed">Mixed</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Reward Value"
            name="rewardValue"
            value={newCampaign.rewardValue}
            onChange={handleInputChange}
            fullWidth
            placeholder="e.g., 1 Month or 0.5%"
          />

          {/* Start Date & End Date */}
          <div className="flex gap-4">
            <TextField
              label="Start Date"
              name="startDate"
              type="date"
              value={newCampaign.startDate}
              onChange={handleInputChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End Date"
              name="endDate"
              type="date"
              value={newCampaign.endDate}
              onChange={handleInputChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button
            onClick={handleAddCampaign}
            variant="contained"
            color="primary"
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CampaignManagementPage
